import { render, staticRenderFns } from "./createOrEditNotesDialog.vue?vue&type=template&id=123e05fa"
import script from "./createOrEditNotesDialog.vue?vue&type=script&lang=js"
export * from "./createOrEditNotesDialog.vue?vue&type=script&lang=js"
import style0 from "./createOrEditNotesDialog.vue?vue&type=style&index=0&id=123e05fa&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports